import { styled } from '@styles';
import { Breadcrumb } from 'react-bootstrap';

export const BC = styled(Breadcrumb)`
  ol {
    background-color: transparent;
  }
`;

export const BCItem = styled(Breadcrumb.Item)`
  background-color: none;
`;

export const Ul = styled.ul`
  margin: 0.5rem 0;
  text-transform: uppercase;
  font-size: xx-small;
  padding-left: 0;
  list-style: none;
`;

export const Li = styled.li`
  display: inline;

  & + &::before {
    float: none;
    padding-right: 0.5rem;
    color: #6c757d;
    content: '/';
  }
`;
